// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import {application} from "./application";

import CartController from "./cart_controller.js";
application.register("cart", CartController);

import RevealController from "./reveal_controller.js";
application.register("reveal", RevealController);

import DeliveryMethodController from "./delivery_method_controller.js";
application.register("delivery-method", DeliveryMethodController);

import ShippingMethodController from "./shipping_method_controller.js";
application.register("shipping-method", ShippingMethodController);

import RequiredFieldsController from "./checkout_validation_controller.js";
application.register("checkout-validation", RequiredFieldsController);

import CheckboxController from "./checkbox_controller.js";
application.register("checkbox", CheckboxController);

import AnimateController from "./animate_controller.js";
application.register("animate", AnimateController);

import GalleryController from "./gallery_controller.js";
application.register("gallery", GalleryController);

import CheckoutController from "./checkout_controller.js";
application.register("checkout", CheckoutController);

import MobileMenuController from "./mobile_menu.js";
application.register("mobile-menu", MobileMenuController);

import SliderController from "./slider.js";
application.register("slider", SliderController);

import VideoBannerController from "./video_banner_controller";
application.register("video-banner", VideoBannerController);

import ChooseCountryController from "./choose_country_controller";
application.register("choose-country", ChooseCountryController);

import ModalController from "./modal_controller";
application.register("modal", ModalController);

import AlertsController from "./alerts_controller";
application.register("alerts", AlertsController);

import SearchController from "./search_controller";
application.register("search", SearchController);

import AddProductController from "./add_product_controller";
application.register("add-product", AddProductController);

import AddProductDropdownController from "./add_product_dropdown_controller";
application.register("add-product-dropdown", AddProductDropdownController);

import AnalyticsController from "./analytics_controller";
application.register("analytics", AnalyticsController);

import CookieConsentController from "./cookie_consent_controller";
application.register("cookie-consent", CookieConsentController);

import AddressAutocompleteController from "./address_autocomplete_controller";
application.register("address-autocomplete", AddressAutocompleteController);

import DropdownController from "./dropdown_controller";
application.register("dropdown", DropdownController);

import AddressBookController from "./address_book_controller";
application.register("address-book", AddressBookController);

import ZoomController from "./zoom_controller";
application.register("zoom", ZoomController);

import CollapseController from "./collapse_controller";
application.register("collapse", CollapseController);

import CheckoutSaveController from "./checkout_save_controller.js";
application.register("checkout-save", CheckoutSaveController);

import TooltipController from "./tooltip_controller.js";
application.register("tooltip", TooltipController);

import ScrollController from "./scroll_controller.js";
application.register("scroll", ScrollController);
